import { Pipe, PipeTransform, inject } from '@angular/core';
import { StaticDataService } from '@mavles/shared';

@Pipe({
    name: 'worksheetProductItem',
    standalone: false
})
export class WorksheetProductItemPipe implements PipeTransform {
  private staticDataService = inject(StaticDataService);


  transform(value: number): unknown {
    let name;
    try {
      this.staticDataService.appConfig.worksheetProducts.forEach(prd => {
        if(Number(prd.product_id) === Number(value)) {
          name = prd.product_name;
          return;
        }
      });
    } catch (error) {
      console.warn(error);
    }
    return name;
  }
}


